import { surnameAddApi } from "../../api/surname/surnameAddApi"

type PayloadShape = Parameters<typeof surnameAddApi>[0]

export async function surnameAddService(payload: PayloadShape, token: string) {
	return await surnameAddApi(payload, token)
}
